import './android-installation-prompt/android-installation-prompt.component';
import './ios-installation-prompt/ios-installation-prompt.component';
import './installation-prompt.component';
import './installation-prompt.service';



// WEBPACK FOOTER //
// ./src/app/common/components/installation-prompt/index.js